import { useAppSelector } from 'dux/app/hooks';

import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import CheckoutBlock from 'Apps/Checkout/Blocks/CheckoutBlock';

import { Typography } from 'Components/Typography';

import { useSssShippingFeeAbTest } from 'abTesting/sssShippingFee/hook';

import {
  skincareMinisWithoutShippingFee,
  skincareMinisWithShippingFee,
} from 'assets/content/skincareMinisModal';
import { productSlugToProductSkincare } from 'assets/content/skincareProducts';

import { convertArrayToStringWithComas } from 'utils/textUtils';

import {
  getCartItemsWithoutCoupons,
  getDeliveryBy,
  getHasSkincareMinisInItems,
  getSubscriptionDiscount,
  getSubscriptionedItems,
} from 'dux/checkoutCart/selectors';
import { VARIANT1 } from 'dux/featureFlags/constants/flagVariants';

const Content = styled.section`
  flex-direction: column;
`;

const Title = styled(Typography)`
  margin-bottom: ${theme.spacing['2x']};
`;

const List = styled.ul`
  padding-left: ${theme.spacing['6x']};
  margin: 0 0 ${theme.spacing['6x']} 0;
`;

export const SubscribeAndSaveSection = () => {
  const subscriptionDiscount = useAppSelector(getSubscriptionDiscount);
  const deliveryBy = useAppSelector(getDeliveryBy);
  const items = useAppSelector(getCartItemsWithoutCoupons) as Array<{ label: string }>;
  const subscribedItems = useAppSelector(getSubscriptionedItems);
  const hasSkincareMinisInItems = useAppSelector(getHasSkincareMinisInItems);

  const { variantName: sssShippingFeeAbTestVariantName } = useSssShippingFeeAbTest();

  const skincareMinisContent =
    sssShippingFeeAbTestVariantName === VARIANT1
      ? skincareMinisWithShippingFee
      : skincareMinisWithoutShippingFee;

  return (
    <CheckoutBlock
      dataTestId="subscribe-and-save"
      title={`Subscribe & save ${subscriptionDiscount}%`}
    >
      <Content>
        <Title bold variant="p2">
          Today&apos;s order:
        </Title>
        <List>
          <li>
            <Typography variant="p2">
              {hasSkincareMinisInItems
                ? skincareMinisContent.subscribeAndSaveSection.label
                : convertArrayToStringWithComas(items.map(({ label }) => label))}
            </Typography>
          </li>
          <li>
            <Typography variant="p2">{deliveryBy}</Typography>
          </li>
        </List>

        <Title bold variant="p2">
          Your future subscription orders:
        </Title>
        <List>
          <li>
            <Typography variant="p2">
              {convertArrayToStringWithComas(
                subscribedItems.map(({ type, label }) =>
                  // @ts-expect-error - skincareProduct.js not Typed
                  hasSkincareMinisInItems ? productSlugToProductSkincare[type].label : label,
                ),
              )}
            </Typography>
          </li>
          <li>
            <Typography variant="p2">FREE shipping</Typography>
          </li>
          <li>
            <Typography variant="p2">Edit or cancel anytime</Typography>
          </li>
        </List>
      </Content>
    </CheckoutBlock>
  );
};
